module.exports = __webpack_public_path__ + "img/fast-forward.4f16271f.svg";